export default __webpack_public_path__ + "static/media/nudge-wave.93caa847.svg";